import React from 'react';
import classNames from 'classnames';
import css from './TopbarDesktop.module.css';


const TopBarLinks = () => {
  return (
    <ul className={classNames(css.topBarLinks)}>
      <li><a className={classNames(css.topBarLinkItem)} target="_blank" href="https://munay.live/blog/join-the-munay-collective/">Practitioners</a></li>
      <li><a className={classNames(css.topBarLinkItem)} target="_blank" href="https://munay.live/blog/collective-wisdom/">Collective Wisdom</a></li>
      <li><a className={classNames(css.topBarLinkItem)} target="_blank" href="https://munay.live/blog/munay-origins-our-purpose/">Munay Origins</a></li>
    </ul>
  );
};

export default TopBarLinks;
